import { IOnlineApprovalTimeEntry } from '../models/online-approval-time-entry.model';
import { PendingTimesheet } from '../models/pending-timesheets.model';

export class UpdateLogic {
    static updateTimeEntries(
        updatedTimedEntries: IOnlineApprovalTimeEntry[],
        existingTimeEntries: IOnlineApprovalTimeEntry[],
    ): IOnlineApprovalTimeEntry[] {
        const updated = [...updatedTimedEntries];
        const existing = [...existingTimeEntries];
        updated?.forEach((te: IOnlineApprovalTimeEntry) => {
            const index = existing?.findIndex(
                (existingTimeEntry: IOnlineApprovalTimeEntry) => existingTimeEntry.id === te?.id,
            );
            if (index !== -1) {
                updated[index] = te;
            }
        });
        return updated;
    }
    static updateTimeEntry(
        updatedTimeEntry: IOnlineApprovalTimeEntry,
        timeEntries: IOnlineApprovalTimeEntry[],
    ): IOnlineApprovalTimeEntry[] {
        const updated = [...timeEntries];
        const index = updated?.findIndex((te: IOnlineApprovalTimeEntry) => te.id === updatedTimeEntry?.id);
        if (index !== -1) {
            updated[index] = updatedTimeEntry;
        }
        return updated;
    }
    static updateTimesheets(
        updatedTimesheets: PendingTimesheet[],
        existingTimesheets: PendingTimesheet[],
    ): PendingTimesheet[] {
        const updated = [...updatedTimesheets];
        const existing = [...existingTimesheets];
        updated?.forEach((ts: PendingTimesheet) => {
            const index = existing?.findIndex(
                (existingTimesheet: PendingTimesheet) => existingTimesheet.timesheetId === ts?.timesheetId,
            );
            if (index !== -1) {
                updated[index] = ts;
            }
        });
        return updated;
    }
    static updateTimesheet(updatedTimesheet: PendingTimesheet, timesheets: PendingTimesheet[]): PendingTimesheet[] {
        const updated = [...timesheets];
        const index = updated?.findIndex((ts: PendingTimesheet) => ts.timesheetId === updatedTimesheet?.timesheetId);
        if (index !== -1) {
            updated[index] = updatedTimesheet;
        }
        return updated;
    }
    static getOriginalTimeEntry(
        timeEntry: IOnlineApprovalTimeEntry,
        originalEntries: IOnlineApprovalTimeEntry[],
    ): IOnlineApprovalTimeEntry {
        const index = originalEntries.findIndex((entry: IOnlineApprovalTimeEntry) => entry.id === timeEntry.id);
        return originalEntries[index];
    }
    static compareTimeEntries(left: IOnlineApprovalTimeEntry, right: IOnlineApprovalTimeEntry): boolean {
        let isEqual = true;

        // one exists but the other doesn't
        if ((left && !right) || (right && !left)) {
            return false;
        }

        Object.keys(left).forEach((key) => {
            if (key === 'isActive' || key === 'hasChanges' || key === 'isInvalid') {
                return;
            }

            if (typeof left[key] === 'function' || typeof right[key] === 'function') {
                if (typeof left[key] !== 'function' || typeof right[key] !== 'function') {
                    isEqual = false;
                }

                return;
            }

            if (left[key]?.toString() !== right[key]?.toString()) {
                isEqual = false;
            }
        });

        return isEqual;
    }
}
